// @ts-strict-ignore
import { JourneyNodeTypesMap } from '@usealloy/typegen';

export const isRetryOutcomeNode = node => (
  node.type === JourneyNodeTypesMap.OUTCOME && node?.data?.config?.outcome === 'Retry'
);

export const isRootNodeType = nodeType => (
  nodeType === JourneyNodeTypesMap.START || nodeType === JourneyNodeTypesMap.SOURCE_WORKFLOW
);

export const isReconciliationWorkflowNodeType = nodeType => (
  nodeType === JourneyNodeTypesMap.RECONCILIATION_WORKFLOW
);
